import { connect } from 'react-redux';
import { withStyles } from '@mui/styles';
import StorageInfo from './StorageInfo';
import styles from './styles';

function mapStateToProps(state) {
  const { isLoadingDetails, data, selectedBox } = state.box;
  return {
    isLoadingDetails,
    data,
    selectedBox,
  };
}

const Styled = withStyles(styles)(StorageInfo);

export default connect(
  mapStateToProps,
)(Styled);
